module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afore39-c8576b3ae08d5010dbc1fad8b9cd4c2a.jpg";